import { faCircleXmark, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { Card, CardBody, FormGroup, Input } from 'reactstrap'
import { setFilterEndDate } from 'store/Recruitment/actions'
import { setFilterJob } from 'store/Recruitment/actions'
import { resetApplicationFilters } from 'store/Recruitment/actions'
import { setFilterJobStage } from 'store/Recruitment/actions'
import { setFilterStartDate } from 'store/Recruitment/actions'
import Select from 'views/pages/Select'
import AiFilteringModal from './AiFilteringModal'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import Interview from './Interview'

function ApplicationsFilters() {
  const dispatch = useDispatch()
  const [showModal, setShowModal] = useState(false)

  const {
    currentSystemSetupRows: jobStages,
    jobs: jobsData,
    filterJob,
    filterJobStage,
    filterEndDate,
    filterStartDate,
  } = useSelector((store) => store.recruitment)

  const [jobs, setJobs] = useState([])

  useEffect(() => {
    setJobs(
      jobsData?.map((el) => {
        return { name: el?.title, id: el?.id, positions: el?.positions }
      })
    )
  }, [jobsData])

  const [showInterview, setShowInterview] = useState(false)

  return (
    <>
      {!showInterview ? (
        <Card>
          <CardBody className='d-flex align-items-center '>
            <div
              role='button'
              onClick={() => setShowModal(true)}
              // style={{ width: '60px', height: '60px' }}
            >
              <button
                onClick={() => setShowModal(true)}
                style={{
                  transition: 'background 0.2s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '8px',
                  padding: '8px 12px',
                  background: '#f5f5f5',
                  color: '#333',
                  border: '1px solid #ccc',
                  borderRadius: '6px',
                  fontWeight: '500',
                  cursor: 'pointer',
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background = '#eee')
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background = '#f5f5f5')
                }
              >
                <span>Review with AI</span>
                <svg
                  viewBox='0 0 200 200'
                  xmlns='http://www.w3.org/2000/svg'
                  style={{ width: '24px', height: '24px' }}
                >
                  <defs>
                    <linearGradient
                      id='aiGradient'
                      x1='0%'
                      y1='0%'
                      x2='100%'
                      y2='100%'
                    >
                      <stop offset='0%' stopColor='#a855f7' />
                      <stop offset='100%' stopColor='#22d3ee' />
                    </linearGradient>
                  </defs>
                  <path
                    d='M100 30 Q115 100 170 100 Q115 100 100 170 Q85 100 30 100 Q85 100 100 30Z'
                    fill='url(#aiGradient)'
                  />
                  <path
                    d='M50 130 Q55 150 70 150 Q55 150 50 170 Q45 150 30 150 Q45 150 50 130Z'
                    fill='url(#aiGradient)'
                  />
                  <path
                    d='M140 40 Q143 50 150 50 Q143 50 140 60 Q137 50 130 50 Q137 50 140 40Z'
                    fill='url(#aiGradient)'
                  />
                </svg>
              </button>
              {/* <button
                className='btn btn-info'
                onClick={() => setShowInterview(true)}
              >
                Test Interview
              </button> */}
            </div>
            <div
              className='d-flex align-items-center w-75 ml-auto'
              style={{ gap: '2rem' }}
            >
              <FormGroup className='w-25'>
                <label className='form-control-label' htmlFor={`field`}>
                  Start Date
                </label>
                <Input
                  type='date'
                  onChange={(e) => dispatch(setFilterStartDate(e.target.value))}
                  value={filterStartDate || ''}
                />
              </FormGroup>
              <FormGroup className='w-25'>
                <label className='form-control-label' htmlFor={`field`}>
                  End Date
                </label>
                <Input
                  type='date'
                  onChange={(e) => dispatch(setFilterEndDate(e.target.value))}
                  value={filterEndDate || ''}
                />
              </FormGroup>
              <div className='w-50 d-flex' style={{ gap: '2rem' }}>
                <FormGroup className='create-job-input '>
                  <label className='form-control-label' htmlFor={`field`}>
                    Stage
                  </label>
                  <Select
                    options={jobStages}
                    valueKey={'id'}
                    multi={false}
                    onChange={(e) => dispatch(setFilterJobStage(e))}
                    selectedOptions={filterJobStage}
                  />
                </FormGroup>
                <FormGroup className='create-job-input'>
                  <label className='form-control-label' htmlFor={`field`}>
                    Job
                  </label>
                  <Select
                    options={jobs}
                    valueKey={'id'}
                    multi={false}
                    onChange={(e) => dispatch(setFilterJob(e))}
                    selectedOptions={filterJob}
                  />
                </FormGroup>
              </div>
              <button
                title='Reset Filters'
                className='btn p-2 btn-danger'
                onClick={() => dispatch(resetApplicationFilters())}
              >
                <FontAwesomeIcon icon={faCircleXmark} size='xl' className='' />
              </button>
            </div>
          </CardBody>
          {showModal && (
            <AiFilteringModal
              showModal={showModal}
              setShowModal={setShowModal}
              jobs={jobs}
            />
          )}
        </Card>
      ) : (
        <Interview />
      )}
    </>
  )
}

export default ApplicationsFilters
